import { z } from "zod";

import { validateSkillDescription } from "@/shared/domain/skills";

/**
 * Validation for the two mutable fields of a skill version.
 *
 * `description` defers to {@link validateSkillDescription} rather than
 * restating the rules as zod constraints: the chat tool's draft handoff
 * validates through that same function, and two copies of "required, ≤ 500
 * chars" would eventually disagree about which one the server enforces.
 *
 * Both fields are checked against their *trimmed* value while the stored value
 * keeps its whitespace — the editor should reject a body of blank lines, but
 * shouldn't quietly reformat what someone typed on save.
 */
export const skillVersionFormSchema = z.object({
  description: z.string().superRefine((value, ctx) => {
    const message = validateSkillDescription(value.trim());
    if (message !== null) {
      ctx.addIssue({ code: "custom", message });
    }
  }),
  body: z.string().refine((value) => value.trim().length > 0, {
    message: "Procedure is required.",
  }),
});

export type SkillVersionFormValues = z.infer<typeof skillVersionFormSchema>;
